export default __webpack_public_path__ + "static/media/shandianqinglidashi_logo.739c5039.png";